import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';
import * as selector from '../../../common/selectors';
import * as regSelector from '../../../common/selectors';
import * as regAction from '../../../common/actions/registration';
import AuthManager from '../../../utils/AuthManager';
import Color from "../../../utils/Color";
import CustomText, { getFontSize, getFontWeight } from '../../components/CustomText';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Must import the CSS
import CustomModal from '../../components/CustomModal';
import { Grid, Popover } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { CheckBox, CheckBoxOutlineBlankOutlined } from '@material-ui/icons';
import Image from "../../../assets";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format, parse, isValid, isBefore, subYears, isAfter } from 'date-fns';
import calendar from '../../../assets/img/calendar.svg';
import ContactModal from "./ContactPopUp";
import { SvgIcon } from '@material-ui/core';

function SmallTickIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            {/* Filled box */}
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="4"
                ry="4"
                fill="currentColor"
            />
            {/* White tick */}
            <path
                d="M7.5 12.5l3.2 3.2L16.5 9.5"   // extended a bit
                stroke="#FFFFFF"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="rotate(-3 12 12)"
            />
        </SvgIcon>
    );
}
// Simple regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export const getNormalizedMediumConsents = (marketing, smsConsent, phoneConsent, emailConsent) => {
    if (!marketing) {
        return {
            SmsConsent: false,
            PhoneConsent: false,
            EmailConsent: false,
        };
    }

    return {
        SmsConsent: !!smsConsent,
        PhoneConsent: !!phoneConsent,
        EmailConsent: !!emailConsent,
    };
};

export const hasAtLeastOneMediumSelected = (mediumConsents) => {
    return !!(mediumConsents?.SmsConsent || mediumConsents?.PhoneConsent || mediumConsents?.EmailConsent);
};

export const shouldShowMediumSelection = (marketing) => !!marketing;

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: "2rem",
        // paddingLeft: '2.7rem',
        // paddingRight: '2.7rem',
        [theme.breakpoints.down('sm')]: {
            paddingTop: "0rem",
            paddingLeft: '0rem',
            paddingRight: '0rem',
            width:"90% !important",
            margin:"auto !important"
        },
        paddingBottom: '2rem',
        overflowY: 'scroll',
        "&::-webkit-scrollbar": { width: "1px" },
        "&::-webkit-scrollbar-track": { background: "#fff" },
        "&::-webkit-scrollbar-thumb": { background: "#fff" },
    },
    headerText: {
        color: '#000000',
        fontSize: 24,
        fontWeight: 700,
        [theme.breakpoints.down('sm')]: {
            fontSize: 24,
        },
    },
    labelTextInputTextStyle: {
        fontWeight: 500,
        fontSize: 14,
        color: '#171717',
        [theme.breakpoints.down('sm')]: {
            fontSize: 13,
        },
    },
    labelTextInputTextStyleError: {
        fontWeight: 500,
        fontSize: 14,
        color: '#EF4444',
    },
    labelTextInputTextStyleSuccess: {
        fontWeight: 500,
        fontSize: 14,
        color: '#10B981',
    },
    textInputContainer: {
        height: 48,
        marginBottom: 25,
        marginTop: 5,
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: 'none',
    },
    textInputContainerError: {
        height: 48,
        marginBottom: 0,
        marginTop: 5,
        //border: '1px solid #EF4444',
        //backgroundColor: '#F0F0F0',
        borderRadius: '4px',
    },
    textInputContainerStrongPassw: {
        height: 48,
        marginBottom: 0,
        marginTop: 5,
        border: '1px solid #10B981',
        //backgroundColor: '#F0F0F0',
        borderRadius: '4px',
    },
    textInputContainerDis: {
        height: 48,
        marginBottom: 25,
        marginTop: 5,
        backgroundColor: "#F2F2F2",
        color: '#B1B1B1 !important',
    },
    errorTextStyle: {
        marginTop: 0,
        marginBottom: 15,
    },
    successTextStyle: {
        marginTop: 0,
        marginBottom: 15,
        color: '#10B981',
    },
    inputContentContainer: {
        marginTop: '1.5rem',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
        flexDirection: 'column',
    },
    buttonStyle: {
        height: '56px',
        backgroundColor: '#FFC107',
        color: '#171717',   
        // [theme.breakpoints.down('sm')]: {
        //     height: '44px',
        // },
    },
    disableBtnStyle: {
        height: '56px',
        backgroundColor: '#F2F2F2 !important',
        color: '#B8BABC !important',
        // [theme.breakpoints.down('sm')]: {
        //     height: '44px',
        // },
        border: 'none !important'
    },
    modalDesign: {
        padding: 0,
        paddingLeft: 15,
        paddingRight: 15,
        paddingBottom: 5,
        textAlign: 'center',
        [theme.breakpoints.down("xs")]: {
            minWidth: 200,
            marginTop: 20,
            marginBottom: 20,
        },
        [theme.breakpoints.up("sm")]: {
            minWidth: 200,
        },
        [theme.breakpoints.up("lg")]: {
            minWidth: 250,
            maxWidth: 250,
        },
        textInputStyle: {
            height: 35,
            marginLeft: 5,
            marginRight: 5,
        },
        containerStyle: {
            flexGrow: 1,
            marginBottom: 30,
            paddingRight: 20,
            marginBottom: 30
        },
        tooltipContainer: {
            display: "flex",
            alignItems: "center",
        },
        titleTextStyle: {
            fontWeight: 'bold',
            fontSize: 25,
        },
    },
    checkboxField: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: '24px',
        border: '1px solid rgba(225, 225, 225, 1)',
        borderRadius: '8px',
        padding: '15px'
    },
    customCheckbox: {
        width: '24px',
        height: '24px',
        // backgroundColor: '#F0F0F0',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '12px',
        flexShrink: 0,
        paddingLeft: 4
    },
    termsContainer: {
        fontSize: 12,
        color: '#000000',
        marginBottom: 5,
        marginTop: 15
    },
    modeContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 0,
        width: '100%',
        marginTop: 15
    },
    modeItem: {
        display: 'flex',
        alignItems: 'center',
        // backgroundColor: '#F0F0F0',
        // padding: '8px 16px',
        borderRadius: 20,
        cursor: 'pointer',
    },
    modeCheckbox: {
        marginRight: 8,
        // color: '#00C853',
    },
}));
const NormalRegNew = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    // --------------------------
    // Local States
    // --------------------------
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneCountryCode, setPhoneCountryCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [dobValue, setDobValue] = useState('');
    const [registrationFormTypeId, setRegistrationFormTypeId] = useState(null);
    // Add NRIC state
    const [nric, setNric] = useState('');
    // Add marketing checkbox state
    const [marketing, setMarketing] = useState(false);
    // Terms visibility
    const [showTerms, setShowTerms] = useState(false);
    // Consent modes
    const [smsConsent, setSmsConsent] = useState(false);
    const [phoneConsent, setPhoneConsent] = useState(false);
    const [emailConsent, setEmailConsent] = useState(false);
    const [mediumConsentError, setMediumConsentError] = useState(false);
    // Validation states
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isDOBValid, setIsDOBValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    // Touched states
    const [emailTouched, setEmailTouched] = useState(false);
    const [dobTouched, setDobTouched] = useState(false);
    const [phoneTouched, setPhoneTouched] = useState(false);
    const [nameTouched, setNameTouched] = useState(false);
    const [nameValid, setNameValid] = useState(true);
    const [nricTouched, setNricTouched] = useState(false);
    const [nricValid, setNricValid] = useState(true);
    // Form errors
    const [formErrors, setFormErrors] = useState({
        nric: false,
        name: false,
        email: false,
        phone: false,
        dob: false,
    });
    // Other states
    const [customToastStatus, setCustomToastStatus] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [countdown, setCountdown] = useState(300); // 5 minutes
    const [backToHome, setBackToHome] = useState(false)
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const customerInfo = useSelector(regSelector.getRegistrationCustomerInfoData);
    const customerInfoLoading = useSelector(regSelector.getRegistrationCustomerInfoLoading);
    const customerInfoStatus = useSelector(regSelector.getRegistrationCustomerInfoStatus);
    const logRegistrationRequestData = useSelector(regSelector.logRegistrationRequestData);
    const logRegistrationRequestLoading = useSelector(regSelector.logRegistrationRequestLoading);
    const [anchorEl, setAnchorEl] = useState(null);
    const [apiDob, setApiDob] = useState('');
    const [calledApi, setCalledApi] = useState(false);

    const loginTokenData = useSelector(regSelector.getLoginTokenData);
    const loginTokenLoading = useSelector(regSelector.getLoginTokenLoading);
    const [localRegId, setLocalRegId] = useState('');
    const [isVisibileContact, setIsVisibileContact] = useState('');
    // --------------------------
    // Countdown Timer
    // --------------------------
    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         setCountdown(prevTime => {
    //             if (prevTime <= 1) {
    //                 clearInterval(timer);
    //                 history.push("/"); // Redirect to home when time is up
    //                 return 0;
    //             }
    //             return prevTime - 1;
    //         });
    //     }, 1000);
    //     return () => clearInterval(timer);
    // }, [history]);

    // Example useEffect if needed, adapted from previous
    useEffect(() => {
        return () => {
            // Cleanup on unmount
            setCalledApi(false)
        };
    }, []);


    // --------------------------
    // Fetch customer info on mount
    // At the top of your component, outside any hooks or callbacks
    const location = useLocation();

    useEffect(() => {
        // Now use the location inside the effect
        const urlParams = new URLSearchParams(location.search);
        let regId = urlParams.get('registrationid') || urlParams.get('registrationId'); // Check both lowercase and camelCase variants

        // If not in URL, fallback to localStorage
        if (!regId) {
            regId = localStorage.getItem('registrationId');
        }
        console.log("regId", regId)
        if (!regId) {
            history.push('/'); // Fallback if no registration id from either source
            return;
        }
        regId = regId.replace(/ /g, '+');
        setLocalRegId(regId)
        // Optional: Store the regId back to localStorage for future use (no changes to value)
        localStorage.setItem('registrationId', regId);
        dispatch(regAction.resetRegAction()); 
        dispatch(regAction.getRegistrationCustomerInfo({ RegistrationId: regId }));
        setIsLoading(true);
    }, []); // Add location to dependencies if the URL can change and you want to re-fetch
    useEffect(() => {
        if (!customerInfoLoading && isLoading) {
            setIsLoading(false);
            console.log("customerInfocustomerInfo", customerInfo?.Data)
            if (customerInfo?.Data) {
                const regData = customerInfo.Data;
                const regSuccess = customerInfo?.Success;
                if (regSuccess) {
                    if (regData?.RegistrationFormTypeId == 5) {
                        dispatch(regAction.getLoginToken({ RegistrationId: localRegId }));
                        setCalledApi(true)
                        return;
                    }
                    if (regData?.RegistrationFormTypeId == 8) {
                        history.push('/OnboardingErr?key=noPolicy');
                        return;
                    }
                    if (regData?.RegistrationFormTypeId == 9) {
                        history.push('/OnboardingErr?key=createFail');
                        return;
                    }
                    setName(regData?.Name || '');
                    localStorage.setItem("localFullName", regData?.Name)
                    setEmail(regData?.Email || '');
                    setPhoneNumber(regData?.Mobile || '');
                    let dobFormatted = '';
                    if (regData?.Dob) {
                        try {
                            const parsedDob = parse(regData.Dob, 'dd MMM yyyy', new Date());
                            dobFormatted = format(parsedDob, 'dd/MM/yyyy');
                        } catch (error) {
                            dobFormatted = regData.Dob;
                        }
                    }
                    setDobValue(dobFormatted);
                    setApiDob(dobFormatted); // Store original API DOB for comparison
                    setRegistrationFormTypeId(regData?.RegistrationFormTypeId || null);
                    // Set NRIC if available, else default
                    regData?.RegistrationFormTypeId == 11 ? setNric("") : setNric(regData?.NRIC || localStorage.getItem('NRIC') || '');
                } else {
                    setDisabledBtn(true);
                }
            } else if (customerInfo?.Data === null) {
                setDisabledBtn(true);
            }
        }
    }, [customerInfo]);

    // Handle getLoginTokenData
    useEffect(() => {
        // if (!submitted) return;
        if (loginTokenLoading) return;

        if (loginTokenData && calledApi) {
            setCalledApi(false)
            if (loginTokenData.Success) {
                const loginData = loginTokenData.Data;
                const token = loginData.token;
                const needSetUserID = loginData.need_set_user_id;
                const isMasterAccount = loginData.is_master_account;
                const sessionExpiryWarning = loginData.session_expiry_warning;
                const sessionExpiryEnd = loginData.session_expiry_end;
                const isDirectClient = loginData.direct_client;
                const sessionId = loginData.session_id;
                AuthManager.setToken(token);
                AuthManager.setSetChangeUserID(needSetUserID);
                AuthManager.setIsMasterAccount(isMasterAccount);
                AuthManager.setDirectClient(isDirectClient);
                AuthManager.setSessionID(sessionId);
                AuthManager.setExpiryWarning(sessionExpiryWarning);
                AuthManager.setExpiryEnd(sessionExpiryEnd);
                window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
                //localStorage.setItem("IsFirstTimeLogin",true)
            } else {
                setCustomToastStatus(true);
                setToastMessage('Login failed. Please try again.');
                window.location.href = process.env.REACT_APP_LOGIN_BASE_URL;
            }
            setCalledApi(false);
        }
    }, [loginTokenData]);
    // --------------------------
    // Determine disabled fields
    // --------------------------
    // const isDobDisabled = (registrationFormTypeId === 6 && dobValue !== '') || ((registrationFormTypeId === 1 || registrationFormTypeId === 3) && dobValue !== '');
    // const isMobileDisabled = (registrationFormTypeId === 3 || registrationFormTypeId === 4 || disabledBtn);
    // const isNameDisabled = (registrationFormTypeId === 1 || registrationFormTypeId === 3) && (name !== '');
    const isDobDisabled = registrationFormTypeId === 6 || registrationFormTypeId === 10 ? true : false;
    const isNricDisabled = registrationFormTypeId === 11 ? false : true; // NRIC always readonly at this step
    const showMobile = registrationFormTypeId === 11 || registrationFormTypeId === 7;
    const showEmail = false; // Hiding for both
    // --------------------------
    // Validation Handlers
    // --------------------------
    const handleNricChange = (val) => {
        const cleaned = val.replace(/[^A-Za-z0-9]/g, '');
        setNric(cleaned.toUpperCase());
        //setNric(val);
        if (!nricTouched && cleaned.length > 0) {
            setNricTouched(true);
        }
        setNricValid(cleaned.length > 0);
    };
    const handleEmailChange = (val) => {
        setEmail(val);
        if (!emailTouched && val.length > 0) {
            setEmailTouched(true);
        }
        setIsEmailValid(val.length > 0 ? emailRegex.test(val.trim()) : false);
    };
    const handleNameChange = (val) => {
        setName(val);
        if (!nameTouched && val.length > 0) {
            setNameTouched(true);
        }
        setNameValid(val.length > 0);
        localStorage.setItem("localFullName", val)
    };
    const handleDOBChange = (raw) => {
        let digits = raw.replace(/\D/g, '').slice(0, 8); // only numbers, max 8
        let display = digits;

        if (digits.length >= 5) {
            display = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
        } else if (digits.length >= 3) {
            display = digits.slice(0, 2) + '/' + digits.slice(2);
        }

        setDobTouched(true);
        setDobValue(display);

        if (digits.length === 8) {
            const dt = parse(display, 'dd/MM/yyyy', new Date());
            const today = new Date();
            const minDOB = subYears(today, 125); // people max 120 years old

            const valid =
                isValid(dt) &&
                isBefore(dt, today) &&   // must be before today
                isAfter(dt, minDOB);     // must not be older than 120 years

            setIsDOBValid(valid);
        } else {
            setIsDOBValid(false);
        }
    };
    const handlePhoneChange = (value, countryData) => {
        setPhoneCountryCode(countryData.dialCode);
        setPhoneNumber(value);
        if (!phoneTouched && value.length > 0) {
            setPhoneTouched(true);
        }
        setIsPhoneValid(value !== phoneCountryCode);
    };
    const handleCalendarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClosePicker = () => {
        setAnchorEl(null);
    };
    const handleDateChange = (date) => {
        if (!date) return;

        const newDate = format(date, 'dd/MM/yyyy');
        const oldDate = dobValue;

        setDobValue(newDate);
        setIsDOBValid(isBefore(date, new Date()));
        setDobTouched(true);

        // ✅ Only close if the *day* is different
        if (oldDate) {
            const newDay = format(date, 'dd');
            const oldDay = format(parse(oldDate, 'dd/MM/yyyy', new Date()), 'dd');

            if (newDay !== oldDay) {
                handleClosePicker();
            }
        } else {
            // if there was no oldDate, close on the first day selection
            //handleClosePicker();
        }
    };
    // --------------------------
    // Field Validation
    // --------------------------
    const validateFields = () => {
        const type11 = registrationFormTypeId === 11;
        const type7 = registrationFormTypeId === 7;
        if (type11) {
            return {
                nric: !nric || !nricValid,
                name: !name || !nameValid,
                email: !email || !isEmailValid,
                phone: !phoneNumber || !isPhoneValid,
                dob: !dobValue || !isDOBValid,
            };
        } else if (type7) {
            return {
                nric: !nric || !nricValid,
                name: !name || !nameValid,
                // email: !email || !isEmailValid,
                phone: !phoneNumber || !isPhoneValid,
                dob: !dobValue || !isDOBValid,
            };
        } else {
            return {
                nric: !nric || !nricValid,
                name: !name || !nameValid,
                // email: !email || !isEmailValid,
                // phone: !phoneNumber || !isPhoneValid,
                dob: !dobValue || !isDOBValid,
            };
        }

    };
    const onClickActivate = () => {
        const mediumConsents = getNormalizedMediumConsents(marketing, smsConsent, phoneConsent, emailConsent);

        if (marketing && !hasAtLeastOneMediumSelected(mediumConsents)) {
            setMediumConsentError(true);
            setCustomToastStatus(true);
            setToastMessage('Please select at least one preferred communication medium.');
            return;
        }

        const errorsFound = validateFields();
        setFormErrors(errorsFound);
        if (Object.values(errorsFound).some(val => val)) {
            setCustomToastStatus(true);
            setToastMessage("Please fill in all required fields correctly.");
            return;
        }
        const isType11 = registrationFormTypeId === 11 || registrationFormTypeId === 7;
        const isDobChanged = dobValue !== apiDob;
        if (isType11 || isDobChanged) {
            const parsedDate = parse(dobValue, "dd/MM/yyyy", new Date());
            const formatted = format(parsedDate, "dd MMM yyyy").toUpperCase();

            const payload = {
                "RegistrationId": localStorage.getItem('registrationId'),
                "Name": name,
                "Email": email,
                "Mobile": phoneNumber || customerInfo?.Data?.Mobile,
                "Dob": formatted,
                "SmsConsent": mediumConsents.SmsConsent,
                "PhoneConsent": mediumConsents.PhoneConsent,
                "EmailConsent": mediumConsents.EmailConsent,
                "Reason": isDobChanged ? 'Change date of birth' : ''
            };
            dispatch(regAction.logRegistrationRequest(payload));
            setCalledApi(true)
            // history.push('/OnboardingErr');
        } else {
            localStorage.setItem('smsConsent', mediumConsents.SmsConsent);
            localStorage.setItem('phoneConsent', mediumConsents.PhoneConsent);
            localStorage.setItem('emailConsent', mediumConsents.EmailConsent);
            history.push('/RegistrationOtp');
        }
    };
    useEffect(() => {
        if (logRegistrationRequestData && calledApi) {
            if (logRegistrationRequestData?.Data === true) {
                history.push('/ReceivedRequest');
            } else {
                history.push('/OnboardingErr');
            }
            // Redirect regardless of success or failure
            // history.push('/OnboardingErr');
        }
    }, [logRegistrationRequestData]);
    // --------------------------
    // Toast Close Handler
    // --------------------------
    const handleCloseCustomToast = (event, reason) => {
        if (reason === 'clickaway') return;
        setCustomToastStatus(false);
    };
    // --------------------------
    // Render Page
    // --------------------------
    const renderPage = () => {
        const nricTextStyle = (formErrors.nric || nricTouched && !nricValid) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const nricDesign = (formErrors.nric || nricTouched && !nricValid) ? classes.textInputContainerError : classes.textInputContainer;
        const nameTextStyle = (formErrors.name || nameTouched && !nameValid) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const nameDesign = (formErrors.name || nameTouched && !nameValid) ? classes.textInputContainerError : classes.textInputContainer;
        const emailTextStyle = (formErrors.email || (emailTouched && !isEmailValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const emailDesign = (formErrors.email || (emailTouched && !isEmailValid)) ? classes.textInputContainerError : classes.textInputContainer;
        const dobTextStyle = (formErrors.dob || (dobTouched && !isDOBValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const dobDesign = (formErrors.dob || (dobTouched && !isDOBValid)) ? classes.textInputContainerError : classes.textInputContainer;
        const phoneTextStyle = (formErrors.phone || (phoneTouched && !isPhoneValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
        const errors = validateFields();
        const isFormInvalid = Object.values(errors).some(val => val);
        const termsContent = {
            title: 'Terms and Conditions for Marketing Consent',
            paragraphs: [
                'I expressly authorise and consent to Etiqa, its officers and employees at their sole discretion, to disclose any and all information relating to me, including my personal particulars, my transactions and dealings and my policies of insurance with Etiqa, to any of the following persons, whether in Singapore or elsewhere:',
                'a) I consent to Etiqa and its related corporations, its agents, authorised service providers and marketing partners collecting, using, disclosing, and/or processing my personal data, in order to contact me about products and services marketed by Etiqa or its partners as well as benefits, promotions and rewards, via the modes mentioned or selected, and using my contact particulars which Etiqa may have in its records from time to time (including where applicable my Singapore telephone number(s));',
                'b) I confirm and agree that my consents granted herein supersede or replace any other consents which I may have previously provided to Etiqa in respect of my personal data, and are additional to any rights which Etiqa may have at law to collect, use or disclose my personal data, unless my consent is withdrawn and notified to Etiqa.',
                <>
                    c) I can manage my marketing consent preferences directly in <span style={{ fontWeight: 'bold' }}>Etiqa+ SG app</span>, including updating or withdrawing my consent. Alternatively, I can choose to withdraw my consent by submitting the Marketing Withdrawal Form at <span style={{ fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer' }}>www.etiqa.com.sg</span> or by emailing <span style={{ fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer' }}>customer.service@etiqa.com.sg</span>.
                </>
            ]
        };
        const isLogReqType = registrationFormTypeId === 11 || registrationFormTypeId === 7;
        return (
            <div className={classes.container}>
                <div className={classes.headerText}>
                    Looks like you’re new! Let’s get you registered
                </div>
                <div className={classes.inputContentContainer}>
                    {/* NRIC/FIN */}
                    <CustomTextInput
                        title={localStorage.getItem('docType') == "PASSPORT" ? "Passport":"NRIC/FIN"}
                        textstyle={nricTextStyle}
                        design={(disabledBtn || isNricDisabled) ? classes.textInputContainerDis : nricDesign}
                        fullWidth
                        value={nric}
                        onChange={(e) => {
                            handleNricChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, nric: false }));
                        }}
                        error={formErrors.nric || nricTouched && !nricValid}
                        errorMessage="Please enter your NRIC/FIN."
                        errorTextStyle={classes.errorTextStyle}
                        disabled={(disabledBtn || isNricDisabled)}
                        borderline={isNricDisabled ? true : false}
                        nricDisabled={disabledBtn || isNricDisabled}
                    />

                    {/* Date of birth */}
                    <CustomTextInput
                        title="Date of birth"
                        textstyle={dobTextStyle}
                        design={(disabledBtn || isDobDisabled || !isLogReqType) ? classes.textInputContainerDis : dobDesign}
                        fullWidth
                        value={dobValue}
                        onChange={(e) => {
                            handleDOBChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, dob: false }));
                        }}
                        error={formErrors.dob || (dobTouched && !isDOBValid)}
                        errorTextStyle={classes.errorTextStyle}
                        errorMessage={!dobValue ? "Please enter your date of birth." : "Invalid date or future date. Use DD/MM/YYYY."}
                        placeholder={"DD/MM/YYYY"}
                        disabled={(disabledBtn || isDobDisabled) ? true : false}
                        endAdornment={
                            <IconButton onClick={(disabledBtn || isDobDisabled ) ? null :handleCalendarClick} style={{padding:'0px'}}> 
                                {/* <CalendarTodayIcon /> */}
                                <img
                                    src={calendar}
                                    className={classes.icon}
                                />
                            </IconButton>
                        }
                        borderline={isLogReqType ? false : true}
                        nricDisabled={(disabledBtn || isDobDisabled ? true: isLogReqType ? false : true)}
                    // borderline={false}
                    />
                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClosePicker}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <DatePicker
                            variant="static"
                            format="dd/MM/yyyy"
                            label="Date of birth"
                            value={dobValue ? parse(dobValue, 'dd/MM/yyyy', new Date()) : null}
                            onChange={handleDateChange}
                            maxDate={new Date()}
                            minDate={new Date(1900, 0, 1)}
                        />
                    </Popover>
                    {/* Name */}
                    <CustomTextInput
                        title="Name"
                        textstyle={nameTextStyle}
                        design={(disabledBtn) ? classes.textInputContainerDis : nameDesign}
                        fullWidth
                        value={name}
                        onChange={(e) => {
                            handleNameChange(e.target.value)
                            setFormErrors(prev => ({ ...prev, name: false }));
                        }}
                        error={formErrors.name || nameTouched && !nameValid}
                        errorMessage="Please enter your name."
                        errorTextStyle={classes.errorTextStyle}
                        disabled={disabledBtn}
                        borderline={(disabledBtn) ? true : false}
                        endAdornment={(
                            <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                            >
                                {/* errorHint.svg */}
                                {(formErrors.name || nameTouched && !nameValid) ? <><img src={Image.errorHint} /></> : <>
                                </>}
                            </IconButton>



                        )}
                    />
                    {/* Mobile */}
                    {showMobile && (
                        <div style={{ width: '100%' }}>
                            <div className={phoneTextStyle} style={{ marginBottom: 5, fontWeight: 400 }}>
                                Mobile Number
                            </div>
                            <div style={{ marginBottom: isLogReqType ? 20 : 25 }}>
                                <PhoneInput
                                    country={'sg'}
                                    value={phoneNumber}
                                    onChange={(val, countryData) => {
                                        handlePhoneChange(val, countryData);
                                        setFormErrors(prev => ({ ...prev, phone: false }));
                                    }}
                                    inputStyle={{
                                        width: '100%',
                                        height: '48px',
                                        backgroundColor: isLogReqType ? '' : '#F0F0F0',
                                        border: isLogReqType ? '' : 'none',
                                        borderRadius: '4px',
                                        borderTopLeftRadius: '0px',
                                        borderBottomLeftRadius: '0px',
                                        color: (formErrors.phone || (!isPhoneValid && phoneTouched)) ? '#EF4444' : ''
                                    }}
                                    buttonStyle={{
                                        backgroundColor: isLogReqType ? '' : '#F0F0F0',
                                        border: isLogReqType ? '' : 'none',
                                        borderRadius: '4px',
                                        borderTopRightRadius: '0px',
                                        borderBottomRightRadius: '0px',
                                        borderRight: '1px solid #DDDDDD',
                                    }}
                                    enableSearch
                                    countryCodeEditable={false}
                                />
                                {(formErrors.phone || (!isPhoneValid && phoneTouched)) && (
                                    <div style={{ color: "#EF4444", fontSize: 12, marginTop: 5 }}>
                                        Please enter your mobile number.
                                    </div>
                                )}
                            </div>

                        </div>
                    )}
                    {registrationFormTypeId === 11 && <CustomTextInput
                        title="Email"
                        textstyle={emailTextStyle}
                        design={disabledBtn ? classes.textInputContainerDis : emailDesign}
                        fullWidth
                        value={email}
                        onChange={(e) => {
                            handleEmailChange(e.target.value);
                            setFormErrors(prev => ({ ...prev, email: false }));
                        }}
                        error={formErrors.email || emailTouched && !isEmailValid}
                        errorMessage={!email ? "Please enter your email." : "Please enter a valid email."}
                        errorTextStyle={classes.errorTextStyle}
                        disabled={disabledBtn}
                        borderline={false}
                        endAdornment={(
                            <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                            >
                                {/* errorHint.svg */}
                                {(formErrors.email || emailTouched && !isEmailValid) ? <><img src={Image.errorHint} /></> : <>
                                </>}
                            </IconButton>



                        )}
                    />}
                    {/* Checkbox */}
                    <div className={classes.checkboxField}>
                        <div style={{fontWeight:'bold',paddingLeft:'0.15rem',marginTop:'-0.4rem',marginBottom:'0.7rem'}}>Stay Informed</div>
                        <label htmlFor="marketing-checkbox" style={{ fontSize: 14, color: '#000000', margin: 0, display: 'flex', alignItems: 'flex-start' }}>
                            <span
                                className={classes.customCheckbox}
                                style={marketing ? { color: '#10B981', cursor: 'pointer' } : { color: '#BDBDBD', cursor: 'pointer' }}
                                onClick={() => {
                                    setMarketing(prev => {
                                        const newMarketing = !prev;
                                        if (!newMarketing) {
                                            setSmsConsent(false);
                                            setPhoneConsent(false);
                                            setEmailConsent(false);
                                            setMediumConsentError(false);
                                        }
                                        return newMarketing;
                                    });
                                }}
                            >
                                {marketing ? <SmallTickIcon className={classes.modeCheckbox} style={{ color: '#10B981' }} /> : <CheckBoxOutlineBlankOutlined className={classes.modeCheckbox} style={{ color: '#BDBDBD' }} />}
                            </span>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
                                    <span>I would like to receive marketing communications from Etiqa about its products, services, offers and promotions.</span>
                                {showTerms && (
                                    <div className={classes.termsContainer}>
                                        <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{termsContent.title}</div>
                                        {termsContent.paragraphs.map((paragraph, index) => (
                                            <React.Fragment key={index}>
                                                <div>{paragraph}</div>
                                                {index < termsContent.paragraphs.length - 1 && <br />}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowTerms(!showTerms);
                                    }}
                                    style={{ color: 'rgba(14, 165, 233, 1)', fontWeight: 'bold', textDecoration: 'none' }}
                                >
                                    {showTerms ? 'Read less' : 'Read more'}
                                </a>
                            </div>
                        </label>
                        {shouldShowMediumSelection(marketing) && (
                            <>
                                <div className={classes.modeContainer}>
                                    <div
                                        className={classes.modeItem}
                                        onClick={() => {
                                            const newValue = !smsConsent;
                                            setSmsConsent(newValue);
                                            if (newValue || phoneConsent || emailConsent) {
                                                setMediumConsentError(false);
                                            }
                                        }}
                                    >
                                        {smsConsent ? <SmallTickIcon className={classes.modeCheckbox} style={{ color: '#10B981' }} /> : <CheckBoxOutlineBlankOutlined className={classes.modeCheckbox} style={{ color: '#BDBDBD' }} />}
                                        SMS
                                    </div>
                                    <div
                                        className={classes.modeItem}
                                        onClick={() => {
                                            const newValue = !phoneConsent;
                                            setPhoneConsent(newValue);
                                            if (newValue || smsConsent || emailConsent) {
                                                setMediumConsentError(false);
                                            }
                                        }}
                                    >
                                        {phoneConsent ? <SmallTickIcon className={classes.modeCheckbox} style={{ color: '#10B981' }} /> : <CheckBoxOutlineBlankOutlined className={classes.modeCheckbox} style={{ color: '#BDBDBD' }} />}
                                        Phone Call
                                    </div>
                                    <div
                                        className={classes.modeItem}
                                        onClick={() => {
                                            const newValue = !emailConsent;
                                            setEmailConsent(newValue);
                                            if (newValue || smsConsent || phoneConsent) {
                                                setMediumConsentError(false);
                                            }
                                        }}
                                    >
                                        {emailConsent ? <SmallTickIcon className={classes.modeCheckbox} style={{ color: '#10B981' }} /> : <CheckBoxOutlineBlankOutlined className={classes.modeCheckbox} style={{ color: '#BDBDBD' }} />}
                                        Email
                                    </div>
                                </div>
                                {mediumConsentError && (
                                    <div style={{ color: '#EF4444', fontSize: 12, marginTop: 8 }}>
                                        Please select at least one preferred communication medium.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
                {/* Next Button */}
                <div style={{ width: '100%', marginTop: '1rem' }}>
                    <CustomButton
                        title="Next"
                        design={isFormInvalid || disabledBtn || isLoading ? classes.disableBtnStyle : classes.buttonStyle}
                        onClick={onClickActivate}
                        disabled={isFormInvalid || disabledBtn || isLoading}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.6rem' }}><span style={{ fontWeight: "bold", color: '#000000' }}>Information mismatch?</span> <span style={{ color: '#0EA5E9', fontWeight: 'bold', marginLeft: '0.3rem', cursor: 'pointer' }} onClick={() => { setIsVisibileContact(true) }}>Contact Us</span></div>
                <ContactModal isVisible={isVisibileContact} onClose={() => setIsVisibileContact(false)} />
            </div>
        );
    };
    const renderMaintenanceChild = () => <></>;
    const height = 800;
    const width = 600;
    const modalContainer = () => {
        return (
            <div className={classes.containerStyle}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className={classes.tooltipContainer}>
                            <CustomText design={classes.titleTextStyle} style={{ marginBottom: 10 }}>
                                {customerInfo?.Data?.Message || "Something went wrong, Please retry later."}
                            </CustomText>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    };
    const onClickNextButton = () => {
        history.push("/")
    };
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <CustomBoardNewLogin
                maintenanceChild={renderMaintenanceChild()}
                children={renderPage()}
                height={height}
                width={width}
                isFixWidth={true}
            />
            <CustomToast
                open={customToastStatus}
                handleCloseCustomToast={handleCloseCustomToast}
                title={toastMessage}
                backToHome={backToHome}
                warning
            />
            <CustomModal
                open={isVisible}
                modalDesign={classes.modalDesign}
                submitButtonText={"OK"}
                modalComponent={modalContainer()}
                disableBackdropClick
                handleSubmitButton={() => onClickNextButton()}
                isVisibleCloseButton={false}
                okBtnSty={true}
            />
            {(customerInfoLoading || logRegistrationRequestLoading || loginTokenLoading) && <LoadingOverlay loading={true} />}
        </MuiPickersUtilsProvider>
    );
};
export default NormalRegNew;